module.exports = __webpack_public_path__ + "0e6d78065347c3f6acdf42bfdc32a42b.svg";